import React from 'react';

interface PagoEfectivoProps {}

const PagoEfectivo: React.FunctionComponent<PagoEfectivoProps> = () => {
    return null;
};

export default PagoEfectivo;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/PagoEfectivo.tsx